import * as http from './http';
import {
  ApiResponse,
  DefaultMapping,
  CustomMappingWithForm,
  ExternalCrmDataField,
} from '../models';
import ApiService from './service';
import { stringify } from 'query-string';
import {
  CreateLinkedinLeadCampaign,
  LinkedinAdForm,
  LinkedinCampaign,
  LinkedinCustomMappingWithForm,
  LinkedinDefaultMapping,
  LinkedinLeadCampaign,
  LinkedinPage,
} from '../models/linkedin';

export class LinkedinService extends ApiService {
  public async createLinkedinPage(data: LinkedinPage) {
    const url = `${this.apiDomain}/api/external-leads/linkedin/page`;

    const response = await http.post<ApiResponse<LinkedinPage>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }
  public async updateLinkedinPage(data: LinkedinPage, id: string) {
    const url = `${this.apiDomain}/api/external-leads/linkedin/page/${id}`;

    const response = await http.put<ApiResponse<LinkedinPage>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }
  public async loadAllLinkedinLeadCampaign(data: { query?: string }) {
    const url = `${this.apiDomain}/api/external-leads/linkedin/lead-campaign?query=${data.query}`;

    const resposne = await http.get<
      ApiResponse<LinkedinLeadCampaign[]> & { lastUpdatedAt: Date }
    >(url, this.store);
    return resposne?.data;
  }

  public async getPages(): Promise<LinkedinPage[]> {
    const url = `${this.apiDomain}/api/external-leads/linkedin/page`;
    const response = await http.get<ApiResponse<LinkedinPage[]>>(
      url,
      this.store
    );
    return response?.data?.data;
  }

  public async getCampaigns(): Promise<LinkedinCampaign[]> {
    const url = `${this.apiDomain}/api/external-leads/linkedin/campaign`;
    const response = await http.get<ApiResponse<LinkedinCampaign[]>>(
      url,
      this.store
    );
    return response?.data?.data;
  }

  public async getForms(pageId: string): Promise<LinkedinAdForm[]> {
    const url = `${this.apiDomain}/api/external-leads/linkedin/ad-form/${pageId}`;
    const response = await http.get<ApiResponse<LinkedinAdForm[]>>(
      url,
      this.store
    );
    return response?.data?.data;
  }

  public async createLinkedinCampaign(data: LinkedinCampaign) {
    const url = `${this.apiDomain}/api/external-leads/linkedin/campaign`;

    const response = await http.post<ApiResponse<LinkedinCampaign>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async createLinkedinLeadCampaign(data: CreateLinkedinLeadCampaign) {
    const url = `${this.apiDomain}/api/external-leads/linkedin/lead-campaign`;

    const response = await http.post<ApiResponse<LinkedinCampaign>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async getPageDetails(pageId: string): Promise<LinkedinPage> {
    const url = `${this.apiDomain}/api/external-leads/linkedin/page/${pageId}`;
    const response = await http.get<ApiResponse<LinkedinPage>>(url, this.store);
    return response?.data?.data;
  }

  public async getLinkedinLeadCampaignDetails(
    id: string
  ): Promise<LinkedinLeadCampaign> {
    const url = `${this.apiDomain}/api/external-leads/linkedin/lead-campaign/${id}`;
    const response = await http.get<ApiResponse<LinkedinLeadCampaign>>(
      url,
      this.store
    );
    return response?.data?.data;
  }

  public async getLeadExternalDataFields() {
    const url = `${this.apiDomain}/api/lead/external-data-fields`;

    const resposne = await http.get<ApiResponse<ExternalCrmDataField[]>>(
      url,
      this.store
    );
    return resposne?.data.data;
  }
  public async createOrUpdateLinkedinFormFields(
    data: LinkedinCustomMappingWithForm
  ) {
    const url = `${this.apiDomain}/api/external-leads/linkedin/form-field`;

    const response = await http.post(url, data, this.store);

    return response?.data?.data;
  }
  public async getLinkedinAdForms() {
    const url = `${this.apiDomain}/api/external-leads/linkedin/ad-form`;

    const resposne = await http.get<ApiResponse<LinkedinAdForm[]>>(
      url,
      this.store
    );
    return resposne?.data.data;
  }
  public async createLinkedinAdForm(data: LinkedinAdForm) {
    const url = `${this.apiDomain}/api/external-leads/linkedin/ad-form`;

    const response = await http.post<ApiResponse<LinkedinAdForm>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }
  public async getLinkedinFormFields(formId?: string) {
    const url = `${
      this.apiDomain
    }/api/external-leads/linkedin/form-field?${stringify({ formId })}`;
    const resposne = await http.get<ApiResponse<LinkedinDefaultMapping[]>>(
      url,
      this.store
    );
    return resposne?.data.data;
  }
  public async getDefaultLinkedinFormFields() {
    const url = `${this.apiDomain}/api/external-leads/linkedin/default-form-field`;

    const resposne = await http.get<
      ApiResponse<{ name: string; value: string }[]>
    >(url, this.store);
    return resposne?.data.data;
  }
}
